"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.817 14.879a1.13 1.13 0 0 1-.668-.218L0 10.894l.59-.807 5.149 3.767c.061.044.144.03.188-.028l9.266-12.5.804.596L6.731 14.42a1.137 1.137 0 0 1-.914.458"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.675 21.989a1.51 1.51 0 0 1-.895-.293L0 16.006l.664-.908 7.78 5.69a.397.397 0 0 0 .552-.083l14-18.884.904.67-14 18.884a1.522 1.522 0 0 1-1.225.614"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.567 29.318c-.416 0-.835-.127-1.194-.39L0 21.341l.885-1.21 10.373 7.586a.529.529 0 0 0 .737-.11l18.666-25.18 1.205.894L13.2 28.5a2.03 2.03 0 0 1-1.633.82"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.547 43.913a2.841 2.841 0 0 1-1.682-.548L.295 31.976l1.107-1.513 15.57 11.388a.984.984 0 0 0 1.368-.207l28.017-37.79 1.506 1.116-28.017 37.79a2.855 2.855 0 0 1-2.3 1.153"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.395 58.55a3.789 3.789 0 0 1-2.242-.73L.394 42.635l1.475-2.018 20.76 15.185a1.312 1.312 0 0 0 1.824-.277L61.81 5.138l2.008 1.489-37.356 50.387a3.807 3.807 0 0 1-3.066 1.537"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCheckmark = function IconCheckmark(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Checkmark' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Checkmark"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCheckmark.sizes = [16, 24, 32, 48, 64];
IconCheckmark.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCheckmark;
exports.default = _default;